import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { WorkAuthorViewStore } from "../../store";
import { WorkAuthorView } from "./WorkAuthorView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type WorkAuthorDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const WorkAuthorDrawerContent: React.FC<WorkAuthorDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new WorkAuthorViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return <WorkAuthorView workAuthorViewStore={viewStore} />;
  });
